/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Service_FaqInputs */

const de_commons_footer_service_faq = /** @type {(inputs: Commons_Footer_Service_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Fragen`)
};

/** @type {(inputs: Commons_Footer_Service_FaqInputs) => LocalizedString} */
const en_commons_footer_service_faq = de_commons_footer_service_faq;

/**

* @param {Commons_Footer_Service_FaqInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_service_faq = /** @type {((inputs?: Commons_Footer_Service_FaqInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Service_FaqInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_service_faq(inputs)
	return en_commons_footer_service_faq(inputs)
});